import { render, staticRenderFns } from "./ConfigurazioneContabilitaTipoDocumentiListPage.vue?vue&type=template&id=836ae8a8"
import script from "./ConfigurazioneContabilitaTipoDocumentiListPage.vue?vue&type=script&lang=js"
export * from "./ConfigurazioneContabilitaTipoDocumentiListPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports